var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { ChevronRightIconGlyph, CrossIconGlyph, EllipsisIconGlyph, PlusIconGlyph, TickIconGlyph } from '@shapeable/icons';
import { useLang } from '../hooks/use-lang';
import { ClipLoader } from 'react-spinners';
import { useThemeEval } from '../hooks/use-theme-eval';
var cls = classNames('app-button');
var AppButtonActionLabels = {
  save: 'Save',
  add: 'Add',
  close: 'Close',
  cancel: 'Cancel',
  done: 'Done',
  choose: 'Choose',
  clear: 'Clear',
  delete: 'Delete'
};
var AppButtonActionTypes = {
  save: 'submit',
  add: 'button',
  close: 'button',
  cancel: 'button',
  done: 'button',
  choose: 'button',
  clear: 'button',
  delete: 'button'
};
var AppButtonActionIcons = {
  save: ChevronRightIconGlyph,
  add: PlusIconGlyph,
  close: CrossIconGlyph,
  cancel: CrossIconGlyph,
  done: TickIconGlyph,
  choose: EllipsisIconGlyph,
  clear: CrossIconGlyph,
  delete: CrossIconGlyph
};
var AppButtonActionVariants = {
  save: 'primary',
  add: 'secondary',
  close: 'secondary',
  cancel: 'secondary',
  done: 'primary',
  choose: 'primary',
  clear: 'secondary',
  delete: 'secondary'
};
var AppButtonActionColors = {
  primary: {
    text: 'light',
    background: 'strong-chrome',
    border: 'strong-chrome',
    fill: 'light',
    hover: {
      background: 'text-chrome',
      border: 'text-chrome'
    }
  },
  secondary: {
    text: 'strong-chrome',
    background: 'canvas',
    border: 'strong-chrome',
    fill: 'strong-chrome',
    hover: {
      background: 'subtle-chrome',
      border: 'text-chrome',
      text: 'text-chrome'
    }
  }
};
export var AppButtonDefaultProps = {
  variant: 'primary'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    ", ";\n\n    font-family: ", ";\n    font-size: 1em;\n    line-height: 1.1em;\n    padding: ", " ", ";\n    border-width: 1px;\n    border-style: solid;\n    border-radius: ", ";\n    cursor: pointer;\n    font-weight: 500;\n    user-select: none;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    outline: 2px solid transparent;\n\n    &:focus {\n      outline-color: ", ";\n    }\n\n    ", "\n\n  "], ["\n    ", ";\n    ", ";\n\n    font-family: ", ";\n    font-size: 1em;\n    line-height: 1.1em;\n    padding: ", " ", ";\n    border-width: 1px;\n    border-style: solid;\n    border-radius: ", ";\n    cursor: pointer;\n    font-weight: 500;\n    user-select: none;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    outline: 2px solid transparent;\n\n    &:focus {\n      outline-color: ", ";\n    }\n\n    ", "\n\n  "])), theme.REMOVE_BUTTON_STYLE, theme.APPLY_COLORS, theme.FONT('app'), theme.UNIT(1.5), theme.UNIT(4.5), theme.UNIT(4), theme.COLOR('strong-chrome'), function (_a) {
    var isDisabled = _a.isDisabled;
    return isDisabled && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      opacity: 0.4;\n      cursor: default;  \n    "], ["\n      opacity: 0.4;\n      cursor: default;  \n    "])));
  })
});
var LabelStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme.UNIT(2))
});
var SpinnerStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-top: -6px;\n  "], ["\n    margin-top: -6px;\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'AppButton',
  Container: styled.button(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Spinner: styled(ClipLoader)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), SpinnerStyles)
};
export var AppButton = function (props) {
  var componentProps = useComponentProps(My.NAME, AppButtonDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    action = componentProps.action,
    onClick = componentProps.onClick,
    disabled = componentProps.disabled,
    loading = componentProps.loading;
  var variant = action ? AppButtonActionVariants[action] || componentProps.variant : componentProps.variant;
  var label = componentProps.label || AppButtonActionLabels[action];
  var Icon = action && AppButtonActionIcons[action];
  var type = componentProps.type || AppButtonActionTypes[action] || 'button';
  var t = useLang();
  var $ = useThemeEval();
  var colors = AppButtonActionColors[variant];
  var spinnerColor = $(theme.COLOR(colors.text));
  return React.createElement(My.Container, {
    type: type,
    disabled: disabled,
    isDisabled: disabled,
    onClick: onClick,
    colors: colors,
    className: cls.name(className)
  }, React.createElement(My.Label, null, t(label)), !loading && Icon && React.createElement(Icon, {
    size: 10,
    style: {
      width: '10px'
    }
  }), loading && React.createElement(My.Spinner, {
    color: spinnerColor,
    size: 6
  }));
};
AppButton.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;